// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DocumentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M20.46 8.87c.26 0 .47.21.47.47v8.45c0 2.6-2.1 4.71-4.68 4.71H7.98c-2.7 0-4.9-2.21-4.9-4.94V6.24c0-2.6 2.1-4.74 4.68-4.74h5.56c.27 0 .47.22.47.48v3.38c0 1.93 1.57 3.5 3.48 3.51z"
        clipRule="evenodd"
        opacity=".5"
      />
      <path d="M17.4 7.34H20c.43 0 .65-.52.35-.84l-2.08-2.2-2.1-2.2c-.32-.34-.86-.11-.86.34v2.77c0 1.16.95 2.12 2.1 2.12" />
    </g>
  </SvgIcon>
);

export default DocumentIcon;
